import React, { Component } from "react";
import { Api } from "../../app-controller.js";

import {
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  Carousel,
} from "reactstrap";

// class MuestraForm extends Component {
//   render() {
//     return (
//       <>
//         <div className={this.props.workingModal ? "" : "hide"}>
//           <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
//             CARGANDO INFORMACIÓN
//           </div>
//         </div>

//         <div className={this.props.workingModal ? "hide" : ""}>

//         </div>
//       </>
//     );
//   }
// }

let styles = {
  width: "70%",
  height: "70vh",
  marginLeft: "auto",
  marginRight: "auto",
  // transform: "rotate(90deg)",
};

class FotosVisita extends Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0, items: [...this.props.state.fotosVisita] };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === this.state.items.length - 1
        ? 0
        : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === 0
        ? this.state.items.length - 1
        : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  render() {
    const { activeIndex } = this.state;

    const slides = this.state.items.map((item) => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.id}
        >
          <img
            style={styles}
            className="d-block img-fluid imgs-visita"
            src={
              Api.url +
              "app/getFoto?url_foto=" +
              encodeURIComponent(item.url_foto)
            }
            alt="prueba"
          />
        </CarouselItem>
      );
    });

    return (
      <div>
        <Carousel
          activeIndex={activeIndex}
          next={this.next}
          previous={this.previous}
        >
          <CarouselIndicators
            items={this.state.items}
            activeIndex={activeIndex}
            onClickHandler={this.goToIndex}
          />
          {slides}
          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={this.previous}
          />
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={this.next}
          />
        </Carousel>
      </div>
    );
  }
}

export default FotosVisita;
